import './modal-team-achievements.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import ModalTemplate from '../modal-template/modal-template';
import TROPHY_FIRST from '../../assets/trophy-first.svg';
import TROPHY_SECOND from '../../assets/trophy-second.svg';
import TROPHY_THIRD from '../../assets/trophy-third.svg';
import UtilsService from '../../services/utils-service';
import TranslateService from '../../services/translate-service';

export default function ModalTeamAchievements(props) {

    return (
        <ModalTemplate className="modal-team-achievements" isOpen={props.isOpen} >
            <div className='flex items-center mb-8'>
                <div className='heading-h6 grow uppercase'>{TranslateService.get('stats.modal.team.title')} ({props.teamAchievements.length})</div>
                <div>
                    <button className='btn-close ' onClick={props.onClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
            </div>

            <div className='max-height'>
                {
                    props.teamAchievements.map((t, index) => (
                        <div  key={index}>
                            <div className='flex items-center mb-[24px]'>
                                {t.posicion === 1 && <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${TROPHY_FIRST}")` }}></div>}
                                {t.posicion === 2 && <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${TROPHY_SECOND}")` }}></div>}
                                {t.posicion === 3 && <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${TROPHY_THIRD}")` }}></div>}

                                <div className='ml-5 grow'>
                                    <h6 className='heading-h6'>{t.nombre}</h6>
                                    <p className='text-secundary text-sm'>{TranslateService.get('stats.modal.team.won')} {UtilsService.formatDate(t.fecha)}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }

                

            </div>
        </ModalTemplate>
    )
}